import { gql } from "@apollo/client";

export const CREATE_Brand = gql`
  mutation createbrand($input: CreateBrandInput!) {
    createBrand(input: $input) {
      success
      message
    }
  }
`;

export const Update_brand = gql`
  mutation updatebrand($input: UpdateBrandInput!) {
    updateBrand(input: $input) {
      success

      message
    }
  }
`;

export const deletebrand = gql`
  mutation deletebrand($id: ID!) {
    deleteBrand(id: $id) {
      success

      message
    }
  }
`;


export const allBrands = gql`
  query {
    allBrands {
      success

      message

      error

      data {
        id

        brandCode

        brandName

        brandLogo

        brandDescription
        user {
          employeeName
        }
        createdAt
      }
    }
  }
`;
